export enum GoalType {
    normal = "normal",
    ownGoal = "ownGoal",
    penalty = "penalty",
    freeKick = "freeKick",
}
